import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { ToastService } from '../../../common-services/Toast/ToastService';
import { strings } from '../../../resources/strings';
import { ReportService } from '../ReportService';
import { GenerateTSOReportInput } from './GenerateTSOReportInput';

export class GenerateTSOReportService extends HttpServiceBase {

  constructor(
    private report: ReportService,
    private toaster: ToastService,
    http?: any | null
  ) {
    super(http);
  }

  handle = (input: GenerateTSOReportInput, version?: number) => {
    const urlVersion = version && version > 0 ? `/v${version}` : '';
    this.http.postToDownloadFile<GenerateTSOReportInput>(
      `${this.baseUrlSislogApi}/v2/report-tso${urlVersion}`,
      input
    ).then(result => {
      this.report.openPdf(result);
    }).catch(error => {
      this.toaster.warning(strings.OpsSomethingWrongGeneratingReport);
    });
  }
}